export enum JobStatusEnum {
    new,
    requesting,
    requested
}
